import { css, styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, maxWidth } from '#/theme/theme';

type ReportSectionVariant = 'default';

const backgroundColorVar = '--background-color';
const borderColorVar = '--border-color';

export const HeaderWrapper = styled.div`
  padding: 0 40px;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-bottom: 50px;
  }
`;

export const SidebarWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 30px;
  flex: 0 0 auto;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding: ${gutterWidth}px 0;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    flex: 1;
  }

  @media print {
    display: none !important;
  }
`;

export const ChartWrapper = styled.div<{
  $hasBorderTop?: boolean;
  $variant: ReportSectionVariant;
}>`
  ${({ $variant }) => {
    switch ($variant) {
      case 'default':
        return `
            ${backgroundColorVar}: ${colors.white};
            ${borderColorVar}: ${colors.brandBlue};
        `;
    }
  }}

  background: var(${backgroundColorVar});
  border-radius: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  padding: ${gutterWidth}px 40px ${gutterWidth * 1.25}px;
  position: relative;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    border-radius: 8px;
    border-top: ${({ $hasBorderTop }) =>
      $hasBorderTop ? `10px solid var(${borderColorVar})` : 'none'};
    flex: 2;
    padding: ${gutterWidth}px 70px ${gutterWidth * 1.25}px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  max-width: ${maxWidth[4]}px;
  margin: 0 auto;
  padding: 30px 0 0;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding: ${gutterWidth}px ${gutterWidth * 2}px;
  }
`;

export const Container = styled.div<{
  $backgroundImage?: string;
  $hasBorderTop?: boolean;
  $variant: ReportSectionVariant;
}>`
  ${({ $variant }) => {
    switch ($variant) {
      case 'default':
        return `
          ${backgroundColorVar}: ${colors.white};
          ${borderColorVar}: ${colors.brandBlue};
      `;
    }
  }}
  align-items: center;
  border-bottom: 1px solid ${colors.elementGrey};
  border-top: ${({ $hasBorderTop }) =>
    $hasBorderTop ? `10px solid var(${borderColorVar})` : 'none'};
  flex-direction: column;
  display: flex;
  position: relative;
  min-height: 100%;
  width: 100%;

  ${(props) =>
    props.$backgroundImage
      ? css`
          background-image: ${props.$backgroundImage};
          background-size: cover;
        `
      : undefined};

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    background-color: ${colors.inputGrey};
    border-bottom: none;
    border-top: none;
    min-height: calc(100vh - 123px);
  }

  @media print {
    &,
    * {
      background: none !important;

      &::before,
      &::after {
        background: none !important;
      }
    }
  }
`;

export const FormWrapper = styled.div`
  padding: 0 40px;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding-left: 0;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding-right: ${gutterWidth * 2}px;
  }

  label {
    display: block;
    color: ${colors.white};
    line-height: 1.25;
    margin-bottom: 0;

    &[for='main-chart-form-job-title'] {
      margin-bottom: 5px;
    }
  }
`;
